import React, { useEffect } from "react";
import SingleMyCourseCard from "./mycourses/SingleMyCourseCard";
import { useDispatch, useSelector } from "react-redux";
import { fetchPartnersMyCourses } from "../../../Redux/PartnersCourses/PartnersCoursesActions";
import PageTitle from "../../../Components/UI/PageTitle";
import Loader from "../../../Components/Loader";

const Mycourses = () => {
  const { loading } = useSelector((state) => state?.UI);
  const { MyCourses } = useSelector((state) => state?.partnersCourses);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchPartnersMyCourses());
  }, []);

  if (loading) return <Loader />;
  return (
    <div>
      <PageTitle title="My Courses" />
      <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-2 tw-gap-5">
        {MyCourses.length > 0 &&
          MyCourses.map((course, courseIndex) => (
            <React.Fragment key={"Course" + courseIndex}>
              <SingleMyCourseCard Course={course} />
            </React.Fragment>
          ))}
      </div>
    </div>
  );
};

export default Mycourses;
